export default "__VITE_ASSET__f9d33397__"